const HTML_TAG = /<\/?[a-z][^>]*>/i;

const escapeHtml = (text: string) =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/**
 * Turns pasted plain text into the HTML the description editor works with: blank lines
 * separate paragraphs, single line breaks stay line breaks. Text that already is HTML is
 * returned as it is.
 */
export const plainTextToHtml = (text: string): string => {
  const trimmed = text.trim();
  if (!trimmed || HTML_TAG.test(trimmed)) return trimmed;

  return trimmed
    .replace(/\r\n?/g, '\n')
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br>')}</p>`)
    .join('');
};

/** Plain text of the description HTML, one paragraph per block. */
export const htmlToPlainText = (html: string): string => {
  if (!html) return '';
  if (!HTML_TAG.test(html)) return html;

  const withBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|h[1-6]|li|blockquote)>/gi, '\n\n');

  const document = new DOMParser().parseFromString(withBreaks, 'text/html');
  return (document.body.textContent ?? '').replace(/\n{3,}/g, '\n\n').trim();
};
